import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoDuoLeftLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/photoDuoLeft" */ './PhotoDuoLeft'), 'PhotoDuoLeftLayout');
